export const awaitAjaxStopPromise = new Promise((resolve) => {
  $(document).ajaxStop(() => resolve());
  window.setTimeout(resolve, 500);
});
